import { render, staticRenderFns } from "./bxbk.vue?vue&type=template&id=21d486a1"
import script from "./bxbk.vue?vue&type=script&lang=js"
export * from "./bxbk.vue?vue&type=script&lang=js"
import style0 from "./bxbk.vue?vue&type=style&index=0&id=21d486a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports